export default __webpack_public_path__ + "static/media/sundarban1.2f55255a.jpg";